import React from "react";
import "./enrolmentContent.css";
import PageTitle from "../master/PageTittle";
import ContentWrapper from "../master/ContentWrapper";
import SideBar from "../master/SideBar";
import { educational } from "../const";

const HSCResults2025 = () => (
  <div className="container">
    <ContentWrapper sidebar={true} narrow={true}>
      <div className={"content"}>
        <PageTitle title="2025 HSC Results" />

        <p>
          We congratulate the class of 2025 for their commitment and hard work,
          we are proud of all our students.
        </p>

        <p>The outstanding highlights were:</p>

        <ul>
          <li>Michael Fares, College Dux – ATAR 99.40</li>
          <li>Quentin Wang – ATAR 95.70</li>
          <li>Lola Ritchie – ATAR 94.55</li>
          <li>Hoang Phung Tran – ATAR 93.80</li>
          <li>The Thien Dao - ATAR 93.10</li>
          <li>Ella Nguyen - ATAR 92.50</li>
          <li>Jake Clemente - ATAR 92.40</li>
          <li>Khoder Ali - ATAR 90.15</li>
        </ul>


        <p>We wish them all the very best in their future endeavors.</p>
      </div>
      <SideBar items={educational} title="Educational Excellence" />
    </ContentWrapper>
  </div>
);

export default HSCResults2025;
